import * as Helpers from "./fillTemplateHelpers";
import addToolTips from "@js/addTooltips";

export default function fillTemplate(contentfulstring, ctx) {
  if (!contentfulstring) return contentfulstring;

  const html = fillTemplateStr(
    contentfulstring.childContentfulRichText.html,
    ctx
  );

  return { childContentfulRichText: { html: addToolTips(html) } };
}

function plaintext(x) {
  return x.replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<");
}

function fillTemplateStr(str, ctx) {
  const escapedstring = str
    .replace(/\\/g, "\\\\") // escape ` within template string
    .replace(/`/g, "\\`")
    .replace(/&quot;/g, '"') // quotes are quotes
    .replace(/<p>/g, "") // use linebreaks instead of paragraphs
    .replace(/<\/p>/g, "\n") // use linebreaks instead of paragraphs
    .replace(
      /^{(.+)\n/gm,
      (_, condition) => "${(" + plaintext(condition) + ") && `"
    ) // { condition ...
    .replace(/\n}\n/gm, "` || ''}") // } end condition
    .replace(/\n(\n*)/g, " $1"); // single linebreak is no linebreak
  //console.log({ str, escapedstring });
  const functionstring = "return `" + escapedstring + "`";

  try {
    const F = Function.constructor(
      ...Object.keys(Helpers),
      ...Object.keys(ctx),
      functionstring
    );
    const evaluated = F(...Object.values(Helpers), ...Object.values(ctx));

    return "<p>" + evaluated.replace(/\n/g, "<p/><p>") + "</p>";
  } catch (exception) {
    return `<p>Error: ${exception}.</p><p>${str}</p>`;
  }
}
